import React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useAssetMVPermissions, useTypedSelector } from '@hooks';
import { toggleShareAssetModal } from '@redux/actions/modalAction';
import { ReactComponent as ShareSvg } from '@assets/icons/share.svg';
import { ReactComponent as DownloadSvg } from '@assets/icons/MediaViewer/download.svg';
import { download } from '@helpers/download';

import DropdownDecisions from '@components/MediaViewerHeader/components/DropdownDecisions';
import AssetsActionMenu from '@pages/MediaViewer/components/AssetsActionMenu';
import ApprovalWorkflowButton from '@components/MediaViewerHeader/components/ApprovalWorkflowButton';
import ApprovalWorkflowDeadline from '@components/MediaViewerHeader/components/ApprovalWorkflowDeadline';
import { LgWidth } from '@components/Responsive';

type HeaderActionsProps = {
  isShowShareBtn?: boolean;
  isShowDownloadBtn?: boolean;
  isShowDeadline?: boolean;
};

function HeaderActions({
  isShowShareBtn = true,
  isShowDownloadBtn = false,
  isShowDeadline = false
}: HeaderActionsProps) {
  const dispatch = useDispatch();
  const canDownload = useAssetMVPermissions('download');
  const asset = useTypedSelector(({ mediaViewer }) => mediaViewer.assets);
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );

  const openShareLinkModal = () => {
    if (selectedVersion && asset) {
      dispatch(
        toggleShareAssetModal({
          visible: true,
          campaignId: asset?.campaignId || '',
          assets: [{ id: asset.id, versionId: selectedVersion.id }],
          defaultName: asset?.asset?.versions[0]?.name || ''
        })
      );
    }
  };

  const isLastVersion =
    selectedVersion?.versionNumber === asset?.asset?.versionsCount;
  const showApprovalButton = asset && selectedVersion;

  return (
    <div className="media_viewer_actions">
      {isShowDeadline && (
        <ApprovalWorkflowDeadline
          approvalWorkflowId={asset?.asset?.approvalWorkflow?.id || ''}
        />
      )}
      {isShowDownloadBtn && canDownload && !!selectedVersion?.sourceUrl && (
        <LgWidth>
          <Button
            className="media_viewer_btn b-only-icon"
            onClick={() => download(selectedVersion.sourceUrl)}
          >
            <DownloadSvg />
          </Button>
        </LgWidth>
      )}
      <AssetsActionMenu />
      {showApprovalButton && (
        <ApprovalWorkflowButton
          asset={asset}
          isLastVersion={isLastVersion}
          selectedVersion={selectedVersion}
        />
      )}
      <DropdownDecisions />
      {isShowShareBtn && (
        <Button
          type="primary"
          className="media_viewer_header-btn-primary media_viewer_header-share-btn"
          onClick={openShareLinkModal}
        >
          <ShareSvg />
          Share
        </Button>
      )}
    </div>
  );
}

export default HeaderActions;
